import React from "react";
import { MARQUEE } from "../data/content";

export function Marquee({ dark = false }) {
  const seq = [...MARQUEE, ...MARQUEE];
  return (
    <div
      className={`marquee-wrap overflow-hidden border-y py-5 ${
        dark ? "bg-moss text-cream border-moss-light" : "bg-cream-2 text-moss border-[#E4DDD0]"
      }`}
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {seq.map((word, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-serif text-2xl sm:text-3xl italic">
            {word}
            <span className="text-gold not-italic text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
